
  function openNotifyPopup() {
    const popup = document.querySelector('.notifyform-popup');
    if (popup) {
      popup.classList.add('open');
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    const popup = document.querySelector('.notifyform-popup');
    const inner = document.querySelector('.notifyform-popup-inner');

    if (popup && inner) {
      popup.addEventListener('click', function () {
        popup.classList.remove('open');
      });

      inner.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }
  });

  function closeNotifyPopup() {
    const popup = document.querySelector('.notifyform-popup');
    if (popup) {
      popup.classList.remove('open');
    }
  }
  

if (
  document.querySelector('body.template-product') &&
  window.location.href.includes('contact_posted=true#ContactForm')
) {
  const popup = document.querySelector('.notifyform-popup');

  if (popup) {
    popup.classList.add('open');

    const cleanUrl = window.location.origin + window.location.pathname;
    window.history.replaceState({}, document.title, cleanUrl);
  }
}



const swiper = document.querySelector('[data-main-pdp-swiper]')?.swiper || false;
let clickTimer = null;
if (swiper) {
  swiper.el.addEventListener('click', function (event) {
    const slide = event.target.closest('.swiper-slide');
    if (!slide) return;
      const mediaToggle = slide.querySelector('.product__media-toggle');
         if (mediaToggle) {
           mediaToggle.click();
         }
    // if (clickTimer) {
    //   clearTimeout(clickTimer);
    //   clickTimer = null;
    //     const mediaToggle = slide.querySelector('.product__media-toggle');
    //     if (mediaToggle) {
    //       mediaToggle.click();
    //     }
    //   return;
    // }
    // clickTimer = setTimeout(() => {
    //   clickTimer = null;
    // }, 250);
  });
}

